import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { WorkloadScalingPolicy } from '@cast/types';

const SCALING_POLICIES_QUERY_KEY = 'inventory-scaling-policies';

export const getScalingPoliciesQueryKey = (clusterId: string) => [
  SCALING_POLICIES_QUERY_KEY,
  clusterId,
];

const getScalingPoliciesQueryOptions = ({
  clusterId,
  enabled,
}: {
  clusterId: string;
  enabled?: boolean;
}) =>
  queryOptions<WorkloadScalingPolicy[]>({
    queryKey: getScalingPoliciesQueryKey(clusterId),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getWorkloadOptimizationPolicies({
          clusterId,
        });
      return data.items || [];
    },
    enabled,
  });

type UseScalingPoliciesArgs = {
  enabled?: boolean;
};

export const useScalingPolicies = ({
  enabled = true,
}: UseScalingPoliciesArgs = {}) => {
  const { cluster } = useCluster();

  const { isLoading, isFetching, data, error, refetch } = useQuery(
    getScalingPoliciesQueryOptions({
      clusterId: cluster.id,
      enabled,
    })
  );

  return {
    policies: data,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};
